export default "__VITE_ASSET__DJjshZAV__"